<div class="aside-inner">
  <nav class="sidebar">
    <ul class="sidebar-nav">
      <li class="has-user-block">
        <app-userblock></app-userblock>
      </li>
      <li [routerLinkActive]="['active']" *ngIf="PaygsetUphideshow">
        <a [routerLink]="['/home']">
          <em class="fas dash-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Home
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/dashboard']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Account Home
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/suppliers']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Contacts
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/items']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Items
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/purchase-orders']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Purchase Order
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/purchase-invoices']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Purchase Invoice
          </p>
        </a>
      </li>

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/orders']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Order
          </p>
        </a>
      </li>

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/vouchers']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Invoice
          </p>
        </a>
      </li>

      <!-- <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/ewaybill']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Eway Bill
          </p>
        </a>
      </li> -->

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/expense-voucher']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
             Voucher
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/pnl']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            P/L Statement
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/accounting/balance-sheet']">
          <em class="fas manage-icon"></em>
          <p style="vertical-align: text-bottom; margin-bottom: 3px !important">
            Balance Sheet
          </p>
        </a>
      </li>
      
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/login']" title="Fastswiff App">
          <!-- <img src="assets/img/fastswifficon/App-1.svg" class="light_icon" /> -->
          <img
            src="assets/img/fastswifficon/logout_white.svg"
            class=""
            style="width: 10%; height: 10%"
          />
          <p
            class="text-dashboard"
            style="vertical-align: text-bottom; margin-bottom: 3px !important"
          >
            Logout
          </p>
        </a>
      </li>
    </ul>
  </nav>
</div>
